<template>
  <div class="usermanagement">
    <h2 class="usermanagement-header fadein">Datenbank-Export</h2>
    <div class="usermanagement-subtitle fadein d100ms">
      Exportiere die komplette Reklamationsliste als ZIP-Datei.
    </div>

    <div class="usermanagement-card fadein d200ms">
      <p>
        Du erhälst:
        <br />– Alle Tabellen der Reklamations-Datenbank (CSV-Dateien)
        <br />– Tabelle <strong>warehouse_claims</strong> als
        <strong>Haupt_Reklamationen.csv</strong>
        <br />– Alle hochgeladenen Anhänge (PDFs) im ZIP
      </p>

      <Button
        :loading="downloading"
        label="Herunterladen"
        icon="pi pi-download"
        class="p-button-primary mt-3"
        @click="downloadExport"
      />
    </div>
  </div>
</template>

<script>
import Button from 'primevue/button'
import axios from 'axios'
import { getAuth } from 'firebase/auth'
import { config } from '@/assets/config.js'
import { useAuthStore } from '@/stores/auth.js'

export default {
  name: 'DatabaseExport',
  components: { Button },
  data() {
    return {
      downloading: false,
      authStore: useAuthStore()
    }
  },
  methods: {
    async downloadExport() {
      try {
        this.downloading = true
        const token = await getAuth().currentUser.getIdToken()

        // Request the ZIP as a binary stream
        const response = await axios.get(
          `${config.api_url}/api/management/database/export`,
          {
            headers: { Authorization: token },
            responseType: 'blob'
          }
        )

        // Create a temporary download link
        const blob = new Blob([response.data], { type: 'application/zip' })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = 'fantasyroom_export.zip'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
      } catch (err) {
        this.$toast?.add({
          severity: 'error',
          summary: 'Fehler beim Export',
          detail: err.message || 'Unbekannter Fehler',
          life: 5000
        })
      } finally {
        this.downloading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.usermanagement {
  &-header {
    margin-bottom: 0;
  }

  &-subtitle {
    color: rgb(192, 192, 192);
  }

  &-card {
    margin-top: 2rem;
    border-radius: 1rem;
    padding: 1rem;
    background-color: var(--surface-0);
  }
}
</style>
